import * as React from "react";
import type { SVGProps } from "react";
const SvgInbound = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="m37.72 63.143.062-4.81c10.075-4.485 17.187-14.646 17.187-25.67 0-11.025-6.825-21.6-17.187-25.985V1.2c15.056 5.147 21.664 18.41 21.664 31.463 0 13.054-8.173 26.11-21.726 30.48Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m36.925 0 1.135.388c15.475 5.29 22.244 18.938 22.244 32.274 0 13.386-8.376 26.799-22.32 31.297l-.128.041h-1.004l.08-6.227.502-.223c9.79-4.358 16.678-14.229 16.678-24.888 0-10.686-6.623-20.947-16.663-25.194l-.524-.221V0Zm1.715 2.42v3.697c10.39 4.65 17.187 15.368 17.187 26.545 0 11.205-7.1 21.504-17.194 26.225l-.04 3.048C51.077 57.342 58.59 45.013 58.59 32.662c0-12.435-6.114-24.973-19.949-30.242Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m37.864 52.108.021-5.504c4.062-2.965 6.396-7.844 6.396-13.547 0-5.702-2.577-11.124-6.727-14.011l.04-5.808c8.134 3.71 11.634 12.358 11.634 19.82 0 7.46-3.315 15.262-11.364 19.051Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m36.745 11.909 1.204.55c8.537 3.892 12.137 12.921 12.137 20.598 0 7.7-3.432 15.861-11.856 19.828l-1.222.576V52.105l.022-5.938.35-.256c3.813-2.782 6.044-7.389 6.044-12.854 0-5.468-2.476-10.605-6.36-13.308l-.37-.258.051-7.582Zm1.697 2.715-.028 3.985c4.195 3.128 6.725 8.68 6.725 14.448 0 5.777-2.305 10.81-6.398 13.976l-.013 3.67C45.515 46.9 48.37 39.88 48.37 33.056c0-6.857-3.045-14.63-9.93-18.433Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M16.143 22.56h11.125L38.37 33.66 27.268 44.764H16.143l7.227-7.223H3.696v-7.758H23.37l-7.228-7.223Zm4.141 1.715 7.229 7.222H5.41v4.33h22.101l-7.227 7.222h6.274l9.388-9.388-9.388-9.386h-6.274Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInbound;
